/**
 * @generated SignedSource<<7250a852bb12e685e4c9eb5b95617333>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type PronounceFeedbackMethodEnum = "AI" | "FUZZY" | "%future added value";
export type pronounceFeedbackQuery$variables = {
  audio: string;
  language: string;
  responseLanguage: string;
  text: string;
};
export type pronounceFeedbackQuery$data = {
  readonly pronounceFeedback: {
    readonly feedback: string | null;
    readonly letter_analysis: ReadonlyArray<{
      readonly letter: string | null;
      readonly score: number | null;
    } | null> | null;
    readonly method: PronounceFeedbackMethodEnum;
    readonly remainingTries: number | null;
    readonly score: number | null;
    readonly transcript: string | null;
  } | null;
};
export type pronounceFeedbackQuery = {
  response: pronounceFeedbackQuery$data;
  variables: pronounceFeedbackQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "audio"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "language"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "responseLanguage"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "text"
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "score",
  "storageKey": null
},
v5 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "audio",
        "variableName": "audio"
      },
      {
        "kind": "Variable",
        "name": "language",
        "variableName": "language"
      },
      {
        "kind": "Variable",
        "name": "responseLanguage",
        "variableName": "responseLanguage"
      },
      {
        "kind": "Variable",
        "name": "text",
        "variableName": "text"
      }
    ],
    "concreteType": "Feedback",
    "kind": "LinkedField",
    "name": "pronounceFeedback",
    "plural": false,
    "selections": [
      (v4/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "feedback",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "LetterScore",
        "kind": "LinkedField",
        "name": "letter_analysis",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "letter",
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "method",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "transcript",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "remainingTries",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "pronounceFeedbackQuery",
    "selections": (v5/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "pronounceFeedbackQuery",
    "selections": (v5/*: any*/)
  },
  "params": {
    "cacheID": "b5df08cab7d68f015c3b25322cb4d5e1",
    "id": null,
    "metadata": {},
    "name": "pronounceFeedbackQuery",
    "operationKind": "query",
    "text": "query pronounceFeedbackQuery(\n  $text: String!\n  $audio: String!\n  $language: String!\n  $responseLanguage: String!\n) {\n  pronounceFeedback(text: $text, audio: $audio, language: $language, responseLanguage: $responseLanguage) {\n    score\n    feedback\n    letter_analysis {\n      letter\n      score\n    }\n    method\n    transcript\n    remainingTries\n  }\n}\n"
  }
};
})();

(node as any).hash = "676018fb8250c82ea06a731297075f5e";

export default node;
